import {openModal} from '../Actions'
import AuthenticateModal from '.';

export const openAuthenticate = ()=>{
	return openModal(AuthenticateModal)
}
